import React from 'react';

// Public landing page for the Singapore 2026 conference invite.
// Renders the 7-page PDF as stacked images — pixel-identical to the
// original artwork, responsive (mobile + desktop), no auth.
export default function SingaporeInvite() {
  const pages = [1, 2, 3, 4, 5, 6, 7];

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#0A1A2F',
        margin: 0,
        padding: 0,
        WebkitFontSmoothing: 'antialiased',
      }}
    >
      <style>{`
        @media (max-width: 600px) {
          .sg-stack { padding: 8px !important; gap: 8px !important; }
        }
      `}</style>
      <div
        className="sg-stack"
        style={{
          maxWidth: 900,
          margin: '0 auto',
          padding: 16,
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
        }}
      >
        {pages.map((p) => (
          <img
            key={p}
            src={`/sg/page-${p}.png`}
            alt={`Singapore 2026 — Page ${p}`}
            loading={p === 1 ? 'eager' : 'lazy'}
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
              borderRadius: 6,
              boxShadow: '0 4px 18px rgba(0,0,0,0.3)',
            }}
          />
        ))}
        {/* Download button intentionally removed — invitation is
            view-only on the live URL. Recipients must visit
            maarkett.com/sg or share that URL with others, rather than
            forwarding a downloaded PDF. */}

        {/* Deomart PRO branding footer — discrete, sits below the
            invitation content. Matches the slate + violet + cyan accent
            used on every Deomart PRO PDF report header. */}
        <div
          style={{
            marginTop: 24,
            padding: '20px 16px 28px',
            borderTop: '1px solid rgba(212, 168, 90, 0.25)',
            textAlign: 'center',
            color: '#94A3B8',
            fontFamily: 'Helvetica, Arial, sans-serif',
          }}
        >
          <div
            style={{
              fontSize: 11,
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              color: '#7C3AED',
              marginBottom: 8,
              fontWeight: 600,
            }}
          >
            Powered by
          </div>
          <div
            style={{
              fontSize: 28,
              fontWeight: 800,
              letterSpacing: '0.04em',
              color: '#E8EAFE',
              fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
              lineHeight: 1.05,
              marginBottom: 4,
            }}
          >
            Deomart PRO
          </div>
          <div
            style={{
              fontSize: 18,
              fontStyle: 'italic',
              color: '#9DD8E5',
              fontFamily: 'Georgia, "Times New Roman", serif',
              lineHeight: 1.2,
            }}
          >
            Retail &amp; Relationships
          </div>
        </div>
      </div>
    </div>
  );
}
